module.exports = __webpack_public_path__ + "img/num_41.d9c0984b.png";